export const BASE_FORM_FIELD_WIDTH = 328;
